import { Component, OnInit } from "@angular/core";
import { AppMainComponent } from "../../../app.main.component";
import { MenuItem } from "primeng/api";
import { AuthService } from "src/app/core/endpoints/auth.service";
import { ApiService } from "src/app/core/services/api.service";

@Component({
	selector: "app-menu",
	templateUrl: "./app.menu.component.html",
})
export class AppMenuComponent implements OnInit {
	public model: any[];
	public notifications: any[];
	public user: any;
	public loading: boolean = true;
	public Admin: MenuItem[] = [
		{
			label: "USUARIOS",
			items: [
				{
					label: "Clientes",
					icon: "pi pi-fw pi-users",
					routerLink: ["users"],
				},
			],
		},
		{
			label: "CONFIGURACIÓN",
			items: [
				{
					label: "Campañas de inversión",
					icon: "pi pi-fw pi-building-columns",
					routerLink: ["investments"],
				},
				
				{
					label: "Importar - Exportar",
					icon: "pi pi-fw pi-database",
					routerLink: ["import"],
				}
			],
		}
	];

	public data: any[];

	constructor(
		public appMain: AppMainComponent,
		private auth: AuthService,
		private apiService: ApiService
	) {}

	ngOnInit() {
		this.model = [
			{
				label: "MENÚ",
				items: [
					{
						label: "Inicio",
						icon: "pi pi-fw pi-align-center",
						routerLink: ["/app"],
					},
					{
						label: "Perfil",
						icon: "pi pi-fw pi-user",
						routerLink: ["my-data"],
					},
				],
			}
		];
		this.getUser();
	}

	onKeydown(event: KeyboardEvent) {
		const nodeElement = <HTMLDivElement>event.target;
		if (event.code === "Enter" || event.code === "Space") {
			nodeElement.click();
			event.preventDefault();
		}
	}

	public getUser() {
		this.apiService.getEntity("user").subscribe({
			next: (result) => {
				this.user = result.user;
				if (this.user.role_id === 1) {
					this.model.push(...this.Admin);
				}

				this.loading = false;
			},
			error: (err) => {
				
			},
			complete: () => {},
		});
	}
}
